export const deductionClassificationsOptions = [
  { value: 'normal', label: '住 [一般の住宅借入金等特別控除（増改築等を含む）]' },
  {
    value: 'special_case_house_normal',
    label: '住(特家) [一般の住宅借入金等特別控除の場合（増改築等を含む。）で住宅が特例居住用家屋に該当するとき]'
  },
  { value: 'ceritified', label: '認 [認定住宅の新築等に係る住宅借入金等特別控除]' },
  {
    value: 'special_case_house_certified',
    label: '認（特家）[認定住宅等の新築等に係る住宅借入金等特別控除の場合で住宅が特例認定住宅等に該当するとき]'
  },
  { value: 'extension', label: '増 [特定増改築等住宅借入金等特別控除]' },
  {
    value: 'earthquake',
    label: '震 [震災特例法第13条の2第１項「住宅の再取得等に係る住宅借入金等特別控除」の規定の適用を選択した場合]'
  },
  {
    value: 'special_case_house_earthquake',
    label: '震（特家）[震災再取得等の適用を選択した場合で住宅が特例居住用家屋に該当するとき]'
  }
];

export const specialDeductionOptiosn = [
  { value: 'none', label: '対象外' },
  { value: 'applied', label: '特定取得' },
  { value: 'special_applied', label: '特別特定取得' },
  { value: 'special_exception_applied', label: '特例特別特例取得' }
];
